module.exports = __webpack_public_path__ + "static/media/LOADER.d91a6ebd.gif";